/* cy-stories: arrows + hover expansion for sections/cy-stories.liquid.
   Hover (mouse, 990px+): the panel under the pointer widens to its picture, the others share the rest, and the
   other cards fade out. The expanded panel is kept while the pointer stays inside its box; a move out picks the neighbour under the pointer. GSAP animates flex-grow (loaded when the section nears the screen);
   without GSAP nothing animates. Touch and reduced-motion users get the plain row. */
(() => {
  const gsapUrl = document.currentScript && document.currentScript.dataset.gsap;
  const reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
  const desk = matchMedia('(min-width:990px) and (hover:hover)');
  const MIN_PANEL = 150; // narrowest a shrunk panel may get (keeps its card readable)

  const loadGsap = () =>
    window.gsap || !gsapUrl
      ? Promise.resolve()
      : new Promise((ok, no) => {
          const s = document.createElement('script');
          s.src = gsapUrl;
          s.onload = ok;
          s.onerror = no;
          document.head.append(s);
        });

  document.querySelectorAll('[data-cy-st]').forEach((root) => {
    const list = root.querySelector('.cy-st__list');
    const prev = root.querySelector('[data-dir="-1"]');
    const next = root.querySelector('[data-dir="1"]');
    if (!list) return;
    const items = [...list.querySelectorAll('.cy-st__item')];
    const cards = items.map((el) => el.querySelector('.cy-st__card')).filter(Boolean);

    // arrows (wide screens): scroll by one panel; state from scroll position
    if (prev && next) {
      let ticking = false;
      const sync = () => {
        ticking = false;
        const max = list.scrollWidth - list.clientWidth;
        root.classList.toggle('cy-st--fit', max <= 2);
        prev.disabled = list.scrollLeft <= 2;
        next.disabled = list.scrollLeft >= max - 2;
      };
      list.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(sync); } }, { passive: true });
      addEventListener('resize', () => requestAnimationFrame(sync), { passive: true });
      const step = (dir) => {
        const w = items[0] ? items[0].getBoundingClientRect().width * 0.8 : list.clientWidth / 2;
        list.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' });
      };
      prev.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      sync();
    }

    if (reduce) return;

    let current = -1; // index of the expanded panel, -1 when none

    const grow = (index) => {
      const g = window.gsap;
      if (!g) return; // GSAP loads as the section nears the screen; hover animates once it is ready
      // widen the hovered panel to its picture (at full panel height) so the whole picture shows; share the rest
      const H = list.clientHeight;
      const W = list.clientWidth;
      const img = items[index].querySelector('.cy-st__media img');
      const ar = img && img.naturalWidth ? img.naturalWidth / img.naturalHeight : 1.6;
      const we = Math.max(MIN_PANEL, Math.min(ar * H, W - (items.length - 1) * MIN_PANEL));
      const ws = (W - we) / (items.length - 1);
      // tween flex-basis in pixels (not flex-grow): the width moves in a straight line instead of snapping open
      g.to(items, { flexBasis: (k) => (k === index ? we : ws), duration: 0.6, ease: 'power3.out', overwrite: 'auto' });
      g.to(cards, { opacity: (k) => (k === index ? 1 : 0), duration: 0.45, ease: 'power2.out', overwrite: 'auto' });
    };
    const reset = () => {
      const g = window.gsap;
      if (!g) return;
      g.to(items, { flexBasis: 0, duration: 0.6, ease: 'power3.out', overwrite: 'auto' });
      g.to(cards, { opacity: 1, duration: 0.45, ease: 'power2.out', overwrite: 'auto' });
    };

    list.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse' || !desk.matches) return;
      if (!window.gsap) loadGsap().catch(() => {});
      // still inside the expanded panel: keep it (moving within a blog must not switch to another one)
      if (current !== -1) {
        const r = items[current].getBoundingClientRect();
        if (e.clientX >= r.left && e.clientX <= r.right) return;
      }
      // otherwise the panel whose left edge is the last one at or before the pointer
      let k = 0;
      items.forEach((el, i) => { if (el.getBoundingClientRect().left <= e.clientX) k = i; });
      if (k === current) return;
      current = k;
      grow(k);
    }, { passive: true });

    list.addEventListener('pointerleave', (e) => {
      if (e.pointerType !== 'mouse' || !desk.matches) return;
      current = -1;
      reset();
    }, { passive: true });

    // fetch GSAP only when the journal is about to be seen
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (entries.some((x) => x.isIntersecting)) {
          io.disconnect();
          loadGsap().catch(() => {});
        }
      }, { rootMargin: '300px' });
      io.observe(root);
    }
  });
})();
